import { ButtonHeading } from "components";
import useDocumentTitle from "hooks/useDocumentTitle";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const LrUploadOption = () => {
  useDocumentTitle("Lr Upload | T360");
  const navigate = useNavigate();
  const accordionData = [
    {
      id: 1,
      title: "Lr Upload",
      show: true,
    },
   
  ];

  return (
    <>
      <ButtonHeading
        title="Quick Upload"
      // onClick={{}} buttonTitle="Reports Sharing"
      />

      <div>
        <div className="accordion" id="quickUploadAccordion">
          <div className="accordion-item" >
            <h2 className="accordion-header" id="headingOne">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                {accordionData[0].title}
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              aria-labelledby="headingOne"
              data-bs-parent="#quickUploadAccordion"

            >
              <div className="accordion-body">
                <div className="row">

                  <div className="col-12 ">
                    <div className="__qwkMain_bx">
                      <div
                        className="_quickCards"
                        onClick={() => navigate("/quick_uploads/lr_uplaod?id=1")}
                      >
                        <div className="_quickCards_body">
                          <div className="text-center">
                            <p className="_fasTruck">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="40px"
                                height="40px"
                                viewBox="0 0 512 512"
                                version="1.1"
                              >
                                <title>details</title>
                                <g
                                  id="Page-1"
                                  stroke="none"
                                  strokeWidth="1"
                                  fill="none"
                                  fillRule="evenodd"
                                >
                                  <g
                                    id="Combined-Shape"
                                    fill="#000000"
                                    transform="translate(64.000000, 64.000000)"
                                  >
                                    <path d="M384,64 L384,384 L64,384 L64,64 L384,64 Z M341.333333,106.666667 L106.666667,106.666667 L106.666667,341.333333 L341.333333,341.333333 L341.333333,106.666667 Z M320,1.42108547e-14 L320,42.6666667 L42.666,42.666 L42.6666667,320 L1.42108547e-14,320 L1.42108547e-14,1.42108547e-14 L320,1.42108547e-14 Z M298.666667,234.666667 L298.666667,277.333333 L149.333333,277.333333 L149.333333,234.666667 L298.666667,234.666667 Z M298.666667,149.333333 L298.666667,192 L149.333333,192 L149.333333,149.333333 L298.666667,149.333333 Z"></path>
                                  </g>
                                </g>
                              </svg>
                            </p>
                            <small className="hash-text">#43534</small>
                            <p className="__qwText">LR Upload</p>
                          </div>
                        </div>
                      </div>
                       <div
                        className="_quickCards"
                        onClick={() => navigate("/quick_uploads/lr_uplaod?id=2")}
                      >
                        <div className="_quickCards_body">
                          <div className="text-center">
                            <p className="_fasTruck">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="40px"
                                height="40px"
                                viewBox="0 0 512 512"
                                version="1.1"
                              >
                                <title>details</title>
                                <g
                                  id="Page-1"
                                  stroke="none"
                                  strokeWidth="1"
                                  fill="none"
                                  fillRule="evenodd"
                                >
                                  <g
                                    id="Combined-Shape"
                                    fill="#000000"
                                    transform="translate(64.000000, 64.000000)"
                                  >
                                    <path d="M384,64 L384,384 L64,384 L64,64 L384,64 Z M341.333333,106.666667 L106.666667,106.666667 L106.666667,341.333333 L341.333333,341.333333 L341.333333,106.666667 Z M320,1.42108547e-14 L320,42.6666667 L42.666,42.666 L42.6666667,320 L1.42108547e-14,320 L1.42108547e-14,1.42108547e-14 L320,1.42108547e-14 Z M298.666667,234.666667 L298.666667,277.333333 L149.333333,277.333333 L149.333333,234.666667 L298.666667,234.666667 Z M298.666667,149.333333 L298.666667,192 L149.333333,192 L149.333333,149.333333 L298.666667,149.333333 Z"></path>
                                  </g>
                                </g>
                              </svg>
                            </p>
                            <small className="hash-text">#43534</small>
                            <p className="__qwText">JK LR Upload</p>
                          </div>
                        </div>
                      </div>
                       <div
                        className="_quickCards"
                        onClick={() => navigate("/quick_uploads/lr_uplaod?id=3")}
                      >
                        <div className="_quickCards_body">
                          <div className="text-center">
                            <p className="_fasTruck">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="40px"
                                height="40px"
                                viewBox="0 0 512 512"
                                version="1.1"
                              >
                                <title>details</title>
                                <g
                                  id="Page-1"
                                  stroke="none"
                                  strokeWidth="1"
                                  fill="none"
                                  fillRule="evenodd"
                                >
                                  <g
                                    id="Combined-Shape"
                                    fill="#000000"
                                    transform="translate(64.000000, 64.000000)"
                                  >
                                    <path d="M384,64 L384,384 L64,384 L64,64 L384,64 Z M341.333333,106.666667 L106.666667,106.666667 L106.666667,341.333333 L341.333333,341.333333 L341.333333,106.666667 Z M320,1.42108547e-14 L320,42.6666667 L42.666,42.666 L42.6666667,320 L1.42108547e-14,320 L1.42108547e-14,1.42108547e-14 L320,1.42108547e-14 Z M298.666667,234.666667 L298.666667,277.333333 L149.333333,277.333333 L149.333333,234.666667 L298.666667,234.666667 Z M298.666667,149.333333 L298.666667,192 L149.333333,192 L149.333333,149.333333 L298.666667,149.333333 Z"></path>
                                  </g>
                                </g>
                              </svg>
                            </p>
                            <small className="hash-text">#43534</small>
                            <p className="__qwText">Adani Lr Upload</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
         
      
        </div>

      </div>
    
    </>
  );
};

export default LrUploadOption;
